<template>
  <div class="app-body">
    <el-tabs v-model="currentTab" type="card">
      <el-tab-pane label="物料库存" name="materail">
        <StoreCountTable  product-type="原料" :show-storage-name="false"></StoreCountTable>
      </el-tab-pane>
      <el-tab-pane label="成品库存" name="product">
        <StoreCountTable  product-type="产品" :show-storage-name="false"></StoreCountTable>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import StoreCountTable from '@/views/modules/erp/store/components/store-count-table.vue'

export default {
  components: { StoreCountTable },
  data(){
    return {
      currentTab:'materail'
    }
  }
}
</script>

<style scoped>

</style>
